<template lang="pug">
#bloco-categoria-monitoramento-socioambiental(
    v-loading='!categorias.length',
    element-loading-background='rgb(255 255 255 / 0%)'
)
    .bloco-categoria-monitoramento-socioambiental-container--loading
        transition(name='el-fade-in-linear', v-if='categorias.length')
            .bloco-categoria-monitoramento-socioambiental-container
                h3 Selecione uma categoria para visualizar os dados do monitoramento
                .bloco-categoria-monitoramento-socioambiental__button
                    button(
                        v-for='(categoria, index) in categorias',
                        @click='selecionarCategoria(categoria, index)',
                        :class='"el-button el-button--default is-round " + categoria.classe'
                    )
                        | {{ getNomeCategoria(categoria) }}
</template>

<script>
import CamadasCategorias from '@/utils/camadasCategorias';

export default {
    name: 'BlocoCategoriaMonitoramentoSocioambiental',

    /**
     * Retorno
     *
     * atualizar-filtro-avancado:
     * {
     *   idCategoriasSelecionados: [],
     * }
     *
     */
    emits: ['atualizar-filtro-avancado'],
    props: {
        removerCategoria: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            categorias: [],
            idCategoriasSelecionados: []
        };
    },
    watch: {
        removerCategoria: function () {
            if (this.removerCategoria.remover) {
                this.removerCategoriaSelecionada(this.removerCategoria.id);
            }
        }
    },

    mounted() {
        this.buscarCategoria();
    },

    methods: {
        removerCategoriaSelecionada(categoriaId) {
            for (let categoriaIndex in this.categorias) {
                if (this.categorias[categoriaIndex].id === categoriaId) {
                    this.categorias[categoriaIndex].classe = '';

                    this.idCategoriasSelecionados =
                        this.idCategoriasSelecionados.filter(
                            c => c !== categoriaId
                        );
                    this.$set(
                        this.categorias,
                        categoriaIndex,
                        this.categorias[categoriaIndex]
                    );
                    this.$emit(
                        'atualizar-filtro-avancado',
                        { idCategorias: [...this.idCategoriasSelecionados] },
                        null
                    );
                    break;
                }
            }
        },
        selecionarCategoria(categoria, index) {
            if (!categoria.classe) {
                categoria.classe =
                    'bloco-categoria-monitoramento-socioambiental__button--active';
                this.idCategoriasSelecionados.push(categoria.id);
            } else {
                categoria.classe = '';
                this.idCategoriasSelecionados =
                    this.idCategoriasSelecionados.filter(
                        c => c !== categoria.id
                    );
            }
            this.$set(this.categorias, index, categoria);

            this.$emit(
                'atualizar-filtro-avancado',
                { idCategorias: [...this.idCategoriasSelecionados] },
                categoria
            );
        },
        buscarCategoria() {
            this.categorias = _.sortBy(
                CamadasCategorias.filter(cc =>
                    [
                        'EMBARGOS_DESMATAMENTO',
                        'SOCIAL',
                        'AREAS_PROTEGIDAS',
                        'REPRESENTANTES'
                    ].includes(cc.codigo)
                ),
                'codigo'
            );

            this.categorias.forEach(function (categoria) {
                categoria.classe = '';
            }, this.categorias);
        },

        getNomeCategoria(categoria) {
            if (categoria.codigo.includes('REPRESENTANTES')) {
                return 'Pessoas';
            } else {
                return categoria.nome;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
#bloco-categoria-monitoramento-socioambiental {
    .bloco-categoria-monitoramento-socioambiental__button--active {
        border-color: var(--secondary-two) !important;
        color: var(--white) !important;
        background: var(--secondary-two) !important;
    }
    .bloco-categoria-monitoramento-socioambiental-container {
        h3 {
            margin-bottom: 10px;
            color: var(--var(--black));
            font-weight: 500;
        }
        .el-button.is-round {
            margin: 2px 3px 0px 2px;
        }
        .el-button.is-round:not(:first-child) {
            margin: 2px 3px 2px 2px;
        }
        .el-button.is-round {
            box-shadow: 0px 0px 2px 0px var(--block-shadow);
            border-radius: 20px;
            padding: 9px 20px;
            min-width: 149px;
            color: var(--primary);
        }
    }

    .bloco-categoria-monitoramento-socioambiental-container--loading {
        min-height: 70px;
    }
}
</style>
